// Set an array of class names into 
// a single DOM Element
const setClasses = function (elem, classArry) {
  if (!elem || !classArry || !Array.isArray(classArry)) return;
  classArry.map(c => elem.classList.add(c));
}